"use client";
// ThemeProviderComponent.tsx
import React from "react";
import { useMediaQuery } from "@mui/material";
import { ThemeProvider, createTheme, lighten } from "@mui/material/styles";
import { useConfig } from "./ConfigProvider";

// Define a component that provides the custom theme using ThemeProvider
const ThemeProviderComponent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const { fontSize } = useConfig();

  // Define your custom theme
  const theme = createTheme({
    // Define your theme properties here
    components: {
      MuiSelect: {
        styleOverrides: {
          select: {
            paddingLeft: "2px",
            fontSize: `${fontSize.dropdown ?? fontSize.default}px`,
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          input: {
            paddingLeft: "2px",
            fontSize: `${fontSize.textBox ?? fontSize.default}px`,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontWeight: "bold",
            fontSize: `${fontSize.label ?? fontSize.default}px`,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: `${fontSize.tab ?? fontSize.default}px`,
            fontWeight: "bold",
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            margin: "12px 0px 0px 0px",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "0px 1px",
          },
          head: {
            fontWeight: "bold",
            fontSize: `${fontSize.gridHeader ?? fontSize.default}px`,
            textAlign: "center",
            padding: "5px 0px",
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          selectLabel: {
            fontSize: `${fontSize.gridPagination ?? fontSize.default}px`,
          },
          displayedRows: {
            fontSize: `${fontSize.gridPagination ?? fontSize.default}px`,
          },
          input: {
            fontSize: `${fontSize.gridPagination ?? fontSize.default}px`,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: `${fontSize.button ?? fontSize.default}px`,
            textTransform: "none",
          },
          containedPrimary: {
            "&:hover": {
              backgroundColor: "#1e8a78",
            },
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              backgroundColor: "orange",
            },
          },
        },
      },
    },
    palette: {
      mode: "light",
      primary: {
        main: "#214c45",
      },
      secondary: {
        main: "#6c757d",
      },
    },
    typography: {
      fontFamily: "Roboto, sans-serif",
      // Other typography styles
    },
    // Other theme properties
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderComponent;
